import React from 'react';
import Blog1 from '../../containers/BlogContainers/Blog1';
import PageHeader from '../Shared/PageHeader';

const BlogStandard = () => {
    return (
        <div>
            <PageHeader title="Blog Standard" />
            <Blog1 />
        </div>
    );
};

export default BlogStandard;